var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M5.56 10l-2.14 2H2v-1h1l2-2h3a1 1 0 0 0 1-1V7H5.5a.5.5 0 0 1 0-1H9V5h1v3a2 2 0 0 1-2 2H5.56zm.794 1.647a4 4 0 1 0 5.118-5.367l.103-1.027A5.002 5.002 0 0 1 10 15a4.999 4.999 0 0 1-4.392-2.608l.746-.745zM8.5 1A1.5 1.5 0 0 1 10 2.5V3a1 1 0 0 1-1 1 1.387 1.387 0 0 1-1.316-.949l-.21-.628A1.081 1.081 0 0 1 8.5 1z" })
  );
});